/* eslint-disable space-before-function-paren */
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import { login } from '@/api/login'
import { clearPending } from '@/utils/request'
import { Loading } from 'element-ui'

NProgress.configure({ showSpinner: false, trickle: false, minimum: 0.8 }) // NProgress Configuration
// 过滤器白名单

const whiteList = ['/login', '/loginTimeOut', '/404', '/role', '/privacy-agreement'] // no redirect whitelist
// const whitewgList = [
//   '/wly/to-goods/data-searching/delivery-search',
//   '/wly/to-goods/data-searching/delivery-search-detail',
//   '/wly/to-goods/data-searching/invoice-check',
//   '/wly/to-goods/data-searching/invoice-search',
//   '/wly/to-goods/business-processing/deliver-approve'
// ]
router.beforeEach(async (to, from, next) => {
  clearPending()
  // start progress bar
  NProgress.start()

  // set page title
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // determine whether the user has logged in
  const hasToken = getToken()
  const isCheckRole = store.getters.isCheckRole

  // hasToken && isCheckRole
  if (hasToken && !to.query.authToken && isCheckRole) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/welcome' })

      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
        } else {
          // determine whether the user has obtained his permission roles through getInfo
          const hasRoutes = store.getters.permission_routes && store.getters.permission_routes.length > 0
          if (hasRoutes) {
            next()
          } else {
            if (to.path === '/role') {
              next()
            } else {
              // 如果 URL 中有 menuCode，先设置到 store
              if (to.query && to.query.menuCode) {
                store.commit('permission/SET_MENU_CODE', to.query.menuCode)
              }
              
              const loading = Loading.service({
                lock: true,
                text: '数据加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              try {
                const accessRoutes = await store.dispatch('permission/generateRoutes')
                // dynamically add accessible routes
                router.addRoutes(accessRoutes)
                loading.close()
                // hack method to ensure that addRoutes is complete
                // set the replace: true, so the navigation will not leave a history record
                next({ ...to, replace: true })
                NProgress.done()
              } catch (error) {
                loading.close()
                // remove token and go to login page to re-login
                await store.dispatch('permission/resetToken')
                next(`/login`)
                NProgress.done()
              }
            }
          }
        }
  } else {
    // 如果有 authToken 跳转流程
    if (to.query?.authToken && to.query.authToken !== 'crmToken' && to.path !== '/role') {
      next('/role?authToken=' + to.query.authToken)
    } else {
      /* has no token*/
      if (whiteList.indexOf(to.path) > -1) {
        next()
      } else {
        next('/login')
      }
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js